module.exports = __webpack_public_path__ + "static/media/Excel.4921adc6.png";